'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _helpers = require('helpers');

var _reactRouter = require('react-router');

var _components2 = require('components');

var _SHARE = require('components/SHARE');

require('./PostponeBasketView.less');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PostponeBasketView: {
        displayName: 'PostponeBasketView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/PostponeBasket/default/PostponeBasketView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PostponeBasketView = _wrapComponent('PostponeBasketView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(PostponeBasketView, _Component);

    function PostponeBasketView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PostponeBasketView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PostponeBasketView.__proto__ || (0, _getPrototypeOf2.default)(PostponeBasketView)).call.apply(_ref, [this].concat(args))), _this), _this.renderPostpones = function (item) {
            var _this$props = _this.props,
                currency = _this$props.currency,
                lang = _this$props.lang;

            var products = null;
            var sumByBasket = 0;
            if (item.items_data === null) {
                return _react3.default.createElement(
                    'div',
                    { className: 'row cart-item flying-to-cart-holder', style: { backgroundColor: '#fff', borderRadius: '7px' } },
                    _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1 text-center' }),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-7' },
                        item.childrenPostpone.map(function (childrenPostpone, i) {
                            products = JSON.parse(childrenPostpone.items_data);
                            return _react3.default.createElement(
                                'div',
                                null,
                                _react3.default.createElement(
                                    'h4',
                                    null,
                                    '\u041A\u043E\u0440\u0437\u0438\u043D\u0430 ',
                                    i + 1
                                ),
                                products.map(function (product) {
                                    sumByBasket = sumByBasket + product.count * product.price;
                                    return _react3.default.createElement(
                                        'div',
                                        null,
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'row no-margin' },
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'col-xs-12 col-sm-8' },
                                                product.name
                                            ),
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'col-xs-12 col-sm-2 text-center' },
                                                product.count
                                            ),
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'col-xs-12 col-sm-2 text-center' },
                                                _react3.default.createElement(_components2.MoneyValue, {
                                                    value: product.price,
                                                    icon: currency.icon,
                                                    iconAfterValue: currency.icon_after_value
                                                })
                                            )
                                        )
                                    );
                                })
                            );
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 text-center' },
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: sumByBasket,
                            icon: currency.icon,
                            iconAfterValue: currency.icon_after_value
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2' },
                        _react3.default.createElement(
                            'div',
                            { className: 'buttons-holder inline_block button_width_100' },
                            _react3.default.createElement(
                                'a',
                                { href: '#', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this.props.inBasketMerged(item.childrenPostpone);
                                    }, className: 'le-button big button_width_100' },
                                lang['store.postpone.checkout']
                            )
                        ),
                        _react3.default.createElement('a', { className: 'close-btn pointer', style: { marginLeft: '5px' }, onClick: function onClick(e) {
                                e.preventDefault();
                                _this.props.onDelete(item.id);
                            } })
                    )
                );
            }
            products = JSON.parse(item.items_data);
            return _react3.default.createElement(
                'div',
                { className: 'row cart-item flying-to-cart-holder', style: { backgroundColor: '#fff', borderRadius: '7px' } },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-1 text-center' },
                    item.parent_id == null ? _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        _react3.default.createElement('input', {
                            type: 'checkbox',
                            className: 'form-check-input',
                            id: item.id,
                            onChange: _this.props.changeSelected,
                            checked: _this.props.selected[item.value]
                        })
                    ) : null
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-7' },
                    products.map(function (product) {
                        sumByBasket = sumByBasket + product.count * product.price;
                        return _react3.default.createElement(
                            'div',
                            { className: 'row no-margin' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-8' },
                                product.name
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2 text-center' },
                                product.count
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2 text-center' },
                                _react3.default.createElement(_components2.MoneyValue, {
                                    value: product.price,
                                    icon: currency.icon,
                                    iconAfterValue: currency.icon_after_value
                                })
                            )
                        );
                    })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 text-center' },
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: sumByBasket,
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value
                    })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'buttons-holder inline_block button_width_100' },
                        _react3.default.createElement(
                            'a',
                            { href: '#', onClick: function onClick(e) {
                                    e.preventDefault();
                                    _this.props.inBasket(products);
                                }, className: 'le-button big button_width_100' },
                            lang['store.common.add_to_cart']
                        )
                    ),
                    _react3.default.createElement('a', { className: 'close-btn pointer', style: { marginLeft: '5px' }, onClick: function onClick(e) {
                            e.preventDefault();
                            _this.props.onDelete(item.id);
                        } })
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PostponeBasketView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                products = _props.products,
                lang = _props.lang,
                items = _props.items;


            return _react3.default.createElement(
                'section',
                { className: 'user-profile' },
                _react3.default.createElement(
                    'div',
                    { className: 'wishlist' },
                    _react3.default.createElement(
                        'h2',
                        { className: 'section-title' },
                        lang['store.postpone.postponeBasket.title']
                    ),
                    items.length ? _react3.default.createElement(
                        'div',
                        null,
                        this.props.countSelected > 1 ? _react3.default.createElement(
                            'div',
                            { className: 'buttons-holder' },
                            _react3.default.createElement(
                                'a',
                                { href: '#', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.props.mergeBaskets();
                                    }, className: 'le-button big button_width_100' },
                                lang['store.postpone.mergeButton']
                            )
                        ) : null,
                        _react3.default.createElement(
                            'div',
                            { className: 'row no-margin cart-item hidden-xs wish_head' },
                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1' }),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-7 text-center' },
                                lang['store.postpone.offers']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2' },
                                lang['store.common.sum']
                            ),
                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'items-holder' },
                            items.map(this.renderPostpones)
                        ),
                        this.props.countSelected > 1 ? _react3.default.createElement(
                            'div',
                            { className: 'buttons-holder' },
                            _react3.default.createElement(
                                'a',
                                { href: '#', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.props.mergeBaskets();
                                    }, className: 'le-button big button_width_100' },
                                lang['store.postpone.mergeButton']
                            )
                        ) : null
                    ) : _react3.default.createElement(
                        'div',
                        { className: 'empty-block' },
                        lang['store.wish_list.empty_wish_list']
                    )
                )
            );
        }
    }]);
    return PostponeBasketView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp2));

exports.default = PostponeBasketView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PostponeBasket/default/PostponeBasketView.jsx
// module id = 1840
// module chunks = 0